import axios from 'axios';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function getAxiosDetailMessage(value: unknown): string | undefined {
  if (isRecord(value) && typeof value.detail === 'string') return value.detail;
  return undefined;
}

export function getAxiosErrorMessage(error_: unknown): string | undefined {
  // axios.isAxiosError is a type guard
  if (axios.isAxiosError(error_)) {
    const detail = getAxiosDetailMessage(error_.response?.data);
    if (detail) return detail;

    // fallback to axios error message
    if (typeof error_.message === 'string' && error_.message.length > 0)
      return error_.message;
    return undefined;
  }

  if (error_ instanceof Error) return error_.message;
  if (typeof error_ === 'string') return error_;
  // last resort
  return undefined;
}

export function getErrorCode(error_: unknown): string {
  function hasCode(thisError: unknown): thisError is {code: string} {
    return (
      typeof thisError === 'object' &&
      thisError !== null &&
      'code' in thisError &&
      // typeof (e as any).code === 'string'
      typeof thisError.code === 'string'
    );
  }

  if (hasCode(error_)) {
    return error_.code;
  }

  return 'None';
}
